<!-- {{ userSQL ||'empty'}}
<p-editor [(ngModel)]="userSQL" [style]="{'height':'320px'}">
    <p-header>
        <span class="ql-formats">
            <button class="fa fa-test" aria-label="Test">Test</button>
        </span>
    </p-header>
</p-editor>

<pre>
    <code class="language-sql" pCode>
        {{ userSQL }}
    </code>
</pre> -->

<!-- <app-ace-editor [metaInfo]="metadata | async"></app-ace-editor> -->
<mat-dialog-content>
    <div fxLayout="row">
        <div fxFlex="1 1 50%" fxLayout="column">
            <ace-editor fxFlex="1 1 auto" [(text)]="text" #editor [mode]="'sql'" (textChanged)="onTextChanged($event)"
                [autoUpdateContent]="true" [style.height.vh]="50"></ace-editor>
            <p-table fxFlex="1 1 auto" [value]="validations" selectionMode="none"
                [scrollable]="true" scrollHeight="15vh" class="message-table" styleClass="p-datatable-striped">
                <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                    <tr>
                        <td style="text-align:left;background-color: black;color:magenta;font-weight: bold;font-size: large;">{{row}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        <p-scrollPanel fxFlex="1 1 50%" [style]="{width: '100%', height: '60vh'}">
            <div fxLayout="column">
                <p-table fxFlex="1 1 auto" class="liquitics-box" [value]="commands" selectionMode="none"
                    [scrollable]="false">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Command</th>
                            <th>Key Binding</th>
                            <th style="width: 50%">Description</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-command let-rowIndex="rowIndex">
                        <tr>
                            <td style="text-align:left">{{command.name}}</td>
                            <td style="text-align:left">{{command.keyBinding}}</td>
                            <td style="text-align:left">{{command.description}}</td>
                        </tr>
                    </ng-template>
                </p-table>
                <div fxLayout="row">
                    <p-table fxFlex="1 1 auto" class="liquitics-box" [value]="hints" selectionMode="none"
                        [scrollable]="true" scrollHeight="35vh" styleClass="p-datatable-striped">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Hints</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr>
                                <td style="text-align:left">{{row}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <p-table fxFlex="1 1 auto" class="liquitics-box" [value]="literalsUsed" selectionMode="none"
                        [scrollable]="true" scrollHeight="35vh" styleClass="p-datatable-striped">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Literals Used</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr>
                                <td style="text-align:left">{{row}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                    <p-table fxFlex="1 1 auto" class="liquitics-box" [value]="numbersUsed" selectionMode="none"
                        [scrollable]="true" scrollHeight="35vh" styleClass="p-datatable-striped">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Numbers Used</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                            <tr>
                                <td style="text-align:left">{{row}}</td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </div>
        </p-scrollPanel>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="editor.getEditor().getValue()">Close</button>
</mat-dialog-actions>